import React from 'react';
import { getBunnyNetEmbedUrl } from '../config/bunnyNet';

interface LiveSessionVideoProps {
  videoId: string;
  title: string;
  description?: string;
  libraryId?: string;
}

export const LiveSessionVideo: React.FC<LiveSessionVideoProps> = ({
  videoId,
  title,
  description,
  libraryId
}) => {
  const embedUrl = getBunnyNetEmbedUrl(videoId, libraryId);

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-xl font-semibold text-[#203D32] mb-2">
          {title}
        </h3>
        {description && (
          <p className="text-gray-600 text-sm">{description}</p>
        )}
      </div>
      
      <div className="relative bg-black">
        <iframe
          src={embedUrl}
          loading="lazy"
          style={{ border: 'none' }}
          title={title}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          className="w-full aspect-video"
        />
      </div>
      
      <div className="p-4 bg-gray-50 border-t border-gray-200">
        <div className="flex items-center space-x-2 text-sm text-gray-600">
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          <span>Session Recording</span>
        </div>
      </div>
    </div>
  );
}; 